<template>
    <div>
        <div class="modal-backdrop show"></div>
        <div class="modal d-block" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ $t('edit_contract_condition') }}</h5>
                        <button type="button" class="close" @click="$emit('close')">
                        <span>&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <label for="name" class="required">Name</label>
                        <app-input 
                            type = "text"
                            v-model = "name" 
                            :required = "true"  
                        />
                        <br>
                        <label for="description" class="required">Description</label>
                        <div v-if="isDataLoaded"> 
                            <app-input  type="text-editor" v-model="description" :minimal="true"/>
                        </div>
                        <br>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="$emit('close')">
                            Close
                        </button>
                        &nbsp;
                        <button type="button" class="btn btn-primary" @click="submit">
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>

import { getDetail } from "./api/api";

export default {
    name: "EditDetail",
    props :{
        id: {
            type: String|Number,
            default: null
        },
    },
    data() {
        return {
            name: "",
            description : "",
            isDataLoaded : false,
        };
    },
    methods: {
        submit() {
            const data = {
                name : this.name,
                description : this.description,
            }
            this.$emit("save", data);
        },

        async getData(id) {
            const res = await getDetail(id);
            if (res.data) {
                const data = res.data;
                this.name = data.name
                this.description = data.description;
                this.isDataLoaded = true;
            }
        }
    },
    mounted(){
        if (this.id) {
            this.getData(this.id);
        }
    }
};
</script>
  